import request from '@/utils/request';

export interface ShareAiGenerateContentParams {
  blockId?: string;
  version?: number;
  generateType?: number;
  voiceId?: number;
  videoId?: number;
  needGenerateVideo?: boolean;
  chatTaskId?: number;
  [property: string]: any;
}

export interface ShareAiGeneratedContentItem {
  blockId?: string;
  generateContent?: string;
  generateContentType?: number;
  generateStatus?: number;
  generateSuccessTime?: string;
  version?: number;
  [property: string]: any;
}

export interface ShareAiGenerateContentResult {
  list?: ShareAiGeneratedContentItem[];
  [property: string]: any;
}

export const feimaChatGroupBlockShareGetAiGenerateContent = (
  data: ShareAiGenerateContentParams,
  options?: any
): Promise<ShareAiGenerateContentResult> =>
  request<any>(
    '/group/block/share/getAiGenerateContent',
    'POST',
    data,
    options
  );

export const feimaChatGroupShareDetail = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.GroupDetailRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.GroupDetailResponse, OT>>(
    '/group/share/detail',
    'POST',
    data,
    options
  );
